import AmioHttpService from './amio-http.service'
import cacheUtils from '@/utils/cache.utils'
import cacheModule from '@/store/modules/cache.module'

class AmioCachedHttpService extends AmioHttpService {

  requestGet(path, config) {
    const cache = cacheUtils.findCache(path, config?.params)
    if (cache) return new Promise(resolve => resolve({ data: cache }))

    return super.requestGet(path, config)
      .then(response => {
        cacheModule.setCache(path, { params: config?.params, data: response.data })
        return response
      })
      .catch(err => {
        throw this.handleError(err)
      })
  }
}

export default AmioCachedHttpService
